import { __assign, __rest } from "tslib";
import React, { useState, forwardRef } from "react";
import { nanoid } from "nanoid";
import { Textarea } from "../Textarea";
import { FormField } from "./FormField";
export var FormTextarea = forwardRef(function (_a, ref) {
    var label = _a.label, id = _a.id, errorLabel = _a.errorLabel, helpLabel = _a.helpLabel, className = _a.className, textareaProps = __rest(_a, ["label", "id", "errorLabel", "helpLabel", "className"]);
    var uid = useState(id || nanoid(8))[0];
    return (React.createElement(FormField, { label: label, htmlFor: uid, errorLabel: errorLabel, helpLabel: helpLabel, className: className },
        React.createElement(Textarea, __assign({ id: uid, ref: ref }, textareaProps))));
});
//# sourceMappingURL=FormTextarea.js.map